import { render, staticRenderFns } from "./CustomerClosedTickets.vue?vue&type=template&id=21d04227&scoped=true&"
import script from "./CustomerClosedTickets.vue?vue&type=script&lang=js&"
export * from "./CustomerClosedTickets.vue?vue&type=script&lang=js&"
import style0 from "./CustomerClosedTickets.vue?vue&type=style&index=0&id=21d04227&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d04227",
  null
  
)

export default component.exports